import { environment } from "src/environments/environment"
import { AppService } from "src/app/core/services/app.service"
import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  private get_dash_url: string

  private buildUrls(dashUrl: string) {
    this.get_dash_url =
      dashUrl + environment.endpointAnalytics.routes.get_dashboard
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointAnalytics.url)
  }

  getAllDashboard() {
    return this.httpClient.get(this.get_dash_url)
  }
}
